;(function () {
  'use strict'

  angular
    .module('contrast.security-controls')
    .factory(
      'securityControlApiConfig',
      function securityControlApiConfigFactory($http, $q, UserService) {
        'ngInject'

        return {
          getSecurityControls: getSecurityControls,
          getSecurityControl: getSecurityControl,
          getSecurityControlsQuickFilters: getSecurityControlsQuickFilters,
          updateSecurityControl: updateSecurityControl,
          toogleControlEnabled: toogleControlEnabled,
          deleteSecurityControl: deleteSecurityControl,

          addValidator: addValidator,
          addValidatorFromTrace: addValidatorFromTrace,

          addSanitizer: addSanitizer,
          addSanitizerFromTrace: addSanitizerFromTrace,

          getSuggestedControls: getSuggestedControls,
          removeSuggestedControl: removeSuggestedControl,
          addSuggestedControl: addSuggestedControl,
          undoSuggestedControl: undoSuggestedControl,
          markApi: markApi
        }

        function getSecurityControls(params) {
          return $http.get(UserService.buildAPIUrl('/controls'), {
            params: params
          })
        }

        function getSecurityControl(id) {
          return $http.get(UserService.buildAPIUrl('/controls/' + id))
        }

        function getSecurityControlsQuickFilters(filters) {
          var httpTimeout = $q.defer(),
            request = $http({
              method: 'get',
              url: UserService.buildAPIUrl('/controls/filters/quick'),
              params: filters,
              timeout: httpTimeout.promise
            })
          request._httpTimeout = httpTimeout
          return request
        }

        function updateSecurityControl(id, control) {
          return $http.put(UserService.buildAPIUrl('/controls/' + id), control)
        }

        function toogleControlEnabled(id) {
          return $http.put(
            UserService.buildAPIUrl('/controls/' + id + '/enabled')
          )
        }

        function deleteSecurityControl(id) {
          return $http['delete'](UserService.buildAPIUrl('/controls/' + id))
        }

        function addValidator(control) {
          return $http.post(
            UserService.buildAPIUrl('/controls/validators'),
            control
          )
        }

        function addValidatorFromTrace(control, traceUuid) {
          return $http.post(
            UserService.buildAPIUrl(
              '/controls/trace/' + traceUuid + '/validator'
            ),
            control
          )
        }

        function addSanitizer(control) {
          return $http.post(
            UserService.buildAPIUrl('/controls/sanitizers'),
            control
          )
        }

        function addSanitizerFromTrace(control, traceUuid) {
          return $http.post(
            UserService.buildAPIUrl(
              '/controls/trace/' + traceUuid + '/sanitizer'
            ),
            control
          )
        }

        function getSuggestedControls(params) {
          return $http.get(UserService.buildAPIUrl('/controls/suggestion'), {
            params: params
          })
        }

        function addSuggestedControl(id, data) {
          return $http.post(
            UserService.buildAPIUrl('/controls/suggestion/' + id),
            data
          )
        }

        function removeSuggestedControl(id) {
          return $http.put(
            UserService.buildAPIUrl('/controls/suggestion/remove/' + id)
          )
        }

        function undoSuggestedControl(id) {
          return $http.put(
            UserService.buildAPIUrl('/controls/suggestion/undo/' + id)
          )
        }

        function markApi(api, language) {
          return $http.post(UserService.buildAPIUrl('/controls/markApi'), {
            api: api,
            language: language
          })
        }
      }
    )
})()
